
import React from "react";
import { Loader2 } from "lucide-react";

export const PublicAgentLoading: React.FC = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin mx-auto mb-4 text-primary" />
        <p className="text-muted-foreground">Loading agent...</p>
      </div>
    </div>
  );
};
